import PT, { checkPropTypes } from 'prop-types';

/**
 * This prop-type validator can be used to validate shadow root instance
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isShadowRootInstance(props, propName, componentName) {
  // validate only if browser supports shadow DOM
  if (typeof window.ShadowRoot === 'function') {
    return checkPropTypes({
      [propName]: PT.instanceOf(window.ShadowRoot)
    }, props, propName, componentName);
  }
  return null;
}

export { isShadowRootInstance as i };
//# sourceMappingURL=isShadowRoot-C-aOK5mv.js.map
